module.exports = __webpack_public_path__ + "static/img/Three-stage-miner.4c6306d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Three-stage-miner.png
// module id = ggRD
// module chunks = 2